import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const ErrorManagement: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m750 750h-300v-120h30v90h240v-195c0-24.81-20.19-45-45-45h-195v60h-30v-90h225c41.36 0 75 33.64 75 75z' />
    <path d='m210 150h30v105h-30z' />
    <circle cx='225' cy='305' r='25' />
    <path d='m480 600h-270v-240h30v210h240z' />
    <path d='m637.37 535.84-60.52 112.65-44.91-59.43c-13.23 9.97-15.86 28.78-5.88 42l33.14 43.9 6.78 9.05c2.95 3.93 7.45 6 12.01 6 3.13 0 6.29-.98 8.99-3 2.59-1.94 6-7 6-7l85-156.44c-14.6-7.82-32.79-2.33-40.61 12.28z' />
    <path d='m397.47 390h-344.94c-8.1 0-15.61-4.17-19.6-10.87-3.78-6.35-3.92-14.03-.39-20.52l172.47-317.05c3.88-7.13 11.54-11.56 19.99-11.56s16.11 4.43 19.99 11.56l172.47 317.05c3.53 6.49 3.39 14.16-.39 20.52-3.99 6.71-11.49 10.87-19.6 10.87zm-351.75-24.22h.01zm20.22-5.78h318.12l-159.06-292.4z' />
  </IconBase>
));

ErrorManagement.displayName = 'ErrorManagement';

export default ErrorManagement;
